import React from "react";

const FilterIcon = ({ className = "" }) => {
  return (
    <svg
      aria-hidden="true"
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 21 18"
      className={className}
    >
      <g id="v4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Discovery-v2--filters-button"
          transform="translate(-62.000000, -531.000000)"
          fill="currentColor"
        >
          <g id="filter-icon" transform="translate(62.000000, 531.000000)">
            <path
              d="M6.03003,1.56003 C6.66003,1.56003 7.20003,2.07003 7.20003,2.73003 C7.20003,3.39003 6.66003,3.90003 6.03003,3.90003 C5.40003,3.90003 4.86003,3.39003 4.86003,2.73003 C4.86003,2.07003 5.40003,1.56003 6.03003,1.56003 M6.00003,0.06003 C4.80003,0.06003 3.78003,0.87003 3.45003,1.98003 L0.72003,1.98003 C0.30003,1.98003 3e-05,2.31003 3e-05,2.73003 C3e-05,3.15003 0.33003,3.48003 0.75003,3.48003 L3.48003,3.48003 C3.78003,4.59003 4.83003,5.40003 6.03003,5.40003 C7.26003,5.40003 8.28003,4.59003 8.61003,3.48003 L19.68003,3.48003 C20.10003,3.48003 20.43003,3.15003 20.43003,2.73003 C20.43003,2.31003 20.10003,1.98003 19.68003,1.98003 L8.61003,1.98003 C8.25003,0.87003 7.23003,0.06003 6.00003,0.06003"
              id="Fill-1"
            ></path>
            <path
              d="M15.2592549,7.81685393 C15.8975903,7.81685393 16.4444309,8.33258427 16.4444309,9 C16.4444309,9.66741573 15.8975903,10.1831461 15.2592549,10.1831461 C14.6206156,10.1831461 14.0737749,9.66741573 14.0737749,9 C14.0737749,8.33258427 14.5905226,7.81685393 15.2592549,7.81685393 M15.228554,6.3 C14.0126771,6.3 12.9794857,7.11910112 12.6448156,8.24157303 L0.759923053,8.24157303 C0.303969221,8.24157303 0,8.5752809 0,9 C0,9.4247191 0.334366143,9.75842697 0.759923053,9.75842697 L12.6448156,9.75842697 C12.9487849,10.8808989 14.0126771,11.7 15.228554,11.7 C16.4751318,11.7 17.5083232,10.8808989 17.8429933,9.75842697 L19.9400769,9.75842697 C20.3659378,9.75842697 20.7,9.4247191 20.7,9 C20.7,8.5752809 20.3659378,8.24157303 19.9400769,8.24157303 L17.8429933,8.24157303 C17.5083232,7.11910112 16.4751318,6.3 15.228554,6.3"
              id="Fill-4"
            ></path>
            <path
              d="M9.63003,14.15988 C10.26003,14.15988 10.80003,14.66988 10.80003,15.32988 C10.80003,15.99018 10.26003,16.50018 9.63003,16.50018 C9.00003,16.50018 8.46003,15.99018 8.46003,15.32988 C8.49003,14.66988 9.00003,14.15988 9.63003,14.15988 M9.60003,12.65988 C8.40003,12.65988 7.38003,13.46988 7.05003,14.57988 L0.75003,14.57988 C0.30003,14.57988 3e-05,14.90988 3e-05,15.32988 C3e-05,15.75018 0.33003,16.07988 0.75003,16.07988 L7.08003,16.07988 C7.38003,17.19018 8.43003,18.00018 9.63003,18.00018 C10.86003,18.00018 11.88003,17.19018 12.21003,16.07988 L19.68003,16.07988 C20.10003,16.07988 20.43003,15.75018 20.43003,15.32988 C20.43003,14.90988 20.10003,14.57988 19.68003,14.57988 L12.18003,14.57988 C11.85003,13.46988 10.83003,12.65988 9.60003,12.65988"
              id="Fill-6"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default FilterIcon;
